import { Box, Text, VStack } from '@chakra-ui/react';
import BundleLogo from '@/icons/BundleLogo.tsx';
import React from 'react';
import { ZIndex } from '@/utils/zIndex.ts';

type OverlaySpinnerProps = {
	text?: string;
	children?: React.ReactNode;
};

export const GlobalOverlayLoader = (props: OverlaySpinnerProps) => {
	return (
		<Box
			position="fixed"
			top="0"
			left="0"
			right="0"
			bottom="0"
			bg="white"
			zIndex={ZIndex.GlobalOverlayLoader}
			display="flex"
			alignItems="center"
			justifyContent="center"
		>
			<VStack alignItems="center" gap={4} p={6} maxW="400px">
				<Box w="300px">
					<Box asChild h="100%" w="auto">
						<BundleLogo />
					</Box>{' '}
					{/* Made it larger and more consistent */}
				</Box>

				<Box animation="bounce 1s ease-in-out infinite alternate">
					<Text fontSize="xl" fontWeight="bold" textAlign="center" lineHeight="1.5">
						{props.text ?? 'We are setting up your bundle now'}
					</Text>
				</Box>

				{props.children}
			</VStack>
		</Box>
	);
};
